export const myJLSMappings: {
  Id: number;
  sequence_name: string;
  user: string;
  abo: string;
}[] = [
  {
    Id: 301,
    sequence_name: "BR Ajoie",
    user: "br.ajoie",
    abo: "Content Service",
  },
  {
    Id: 81,
    sequence_name: "BR Alpes Chablais Vaudois",
    user: "br.alpes-chablais-vaudois",
    abo: "Content Service",
  },
  {
    Id: 141,
    sequence_name: "BR Basso Ceresio",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 245,
    sequence_name: "BR Basso Mendrisiotto",
    user: "br.basso-mendrisiotto",
    abo: "Content Service",
  },
  {
    Id: 313,
    sequence_name: "BR Bellinzonese e Visagno",
    user: "br.bellinzonese",
    abo: "Content Service",
  },
  {
    Id: 85,
    sequence_name: "BR Broye-Vully-Lacs",
    user: "br.broye",
    abo: "Content Service",
  },
  {
    Id: 86,
    sequence_name: "BR Broye-Vully-Lacs",
    user: "br.broye-vully-lacs",
    abo: "Content Service",
  },
  {
    Id: 125,
    sequence_name: "BR Communes du Haut-Plateau",
    user: "br.communes du haut-plateau",
    abo: "Content Service",
  },
  {
    Id: 162,
    sequence_name: "BR de la Riviera",
    user: "br.riviera",
    abo: "Content Service",
  },
  {
    Id: 300,
    sequence_name: "BR de Lavaux",
    user: "br.du lavaux",
    abo: "Content Service",
  },
  {
    Id: 238,
    sequence_name: "BR del Camoghe",
    user: "br.delcamoghe",
    abo: "Content Service",
  },
  {
    Id: 112,
    sequence_name: "BR della Campagnadorna",
    user: "br.campagnadorna",
    abo: "Content Service",
  },
  {
    Id: 862,
    sequence_name: "BR della Magliasina",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 1192,
    sequence_name: "BR del Malcantone",
    user: "br.malcantone",
    abo: "Content Service",
  },
  {
    Id: 257,
    sequence_name: "BR del Vedeggio",
    user: "br.del vedeggio",
    abo: "Content Service",
  },
  {
    Id: 796,
    sequence_name: "BR des Montagnes Neuchâteloises",
    user: "br.des montagnes neuchateloises",
    abo: "Content Service",
  },
  {
    Id: 107,
    sequence_name: "BR du Gros-de-Vaud",
    user: "br.du Gros-de-Vaud",
    abo: "Content Service",
  },
  {
    Id: 319,
    sequence_name: "BR du Haut-Léman",
    user: "br.haut-leman",
    abo: "Content Service",
  },
  {
    Id: 224,
    sequence_name: "BR Du Val-de-Ruz",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 63,
    sequence_name: "BR du Val-Terbi",
    user: "br.val-terbi",
    abo: "Content Service",
  },
  {
    Id: 242,
    sequence_name: "BR Entremont",
    user: "br.dentremont",
    abo: "Content Service",
  },
  {
    Id: 134,
    sequence_name: "BR Fribourg Ouest (= West)",
    user: "br.fribourg-ouest",
    abo: "Content Service",
  },
  {
    Id: 361,
    sequence_name: "BR Genève Rive Gauche",
    user: "br.geneve-rive",
    abo: "Content Service",
  },
  {
    Id: 216,
    sequence_name: "BR Lausanne",
    user: "br.Lausanne",
    abo: "Content Service",
  },
  {
    Id: 362,
    sequence_name: "BR Locarno",
    user: "br.locarno",
    abo: "Content Service",
  },
  {
    Id: 133,
    sequence_name: "BR Martigny et Région",
    user: "br.martigny-et-region",
    abo: "Content Service",
  },
  {
    Id: 156,
    sequence_name: "BR Moléson",
    user: "br.moléson",
    abo: "Content Service",
  },
  {
    Id: 227,
    sequence_name: "BR Morbio-Vacallo",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 150,
    sequence_name: "BR Morges Venoge",
    user: "br.morges venoge",
    abo: "Content Service",
  },
  {
    Id: 325,
    sequence_name: "BR Neuchâtel et Vallées",
    user: "br.neuchatel",
    abo: "Content Service",
  },
  {
    Id: 1556,
    sequence_name: "BR Piano di Magadino",
    user: "br.piano-di-magadino",
    abo: "Content Service",
  },
  {
    Id: 260,
    sequence_name: "BR Pierre-Pertuis",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 144,
    sequence_name: "BR Région Delémont",
    user: "br.delémont",
    abo: "Content Service",
  },
  {
    Id: 94,
    sequence_name: "BR Région Genève Rhône",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 231,
    sequence_name: "BR Tre Valli",
    user: "br.tre valli",
    abo: "Content Service",
  },
  {
    Id: 261,
    sequence_name: "BR Yverdon-les-Bains",
    user: "br.d'yverdon-les-bains",
    abo: "Content Service",
  },
  {
    Id: 101,
    sequence_name: "RB Aarau-Lenzburg",
    user: "rb.aarau-lenzburg",
    abo: "Content Studio",
  },
  {
    Id: 72,
    sequence_name: "RB Aare-Rhein",
    user: "rb.aare-rhein",
    abo: "Content Studio",
  },
  {
    Id: 1456,
    sequence_name: "RB Adligenswil-Udligenswil-Meggen",
    user: "rb.adligenswil",
    abo: "Content Service",
  },
  {
    Id: 145,
    sequence_name: "RB Aesch-Pfeffingen",
    user: "rb.aesch",
    abo: "Content Service",
  },
  {
    Id: 131,
    sequence_name: "RB Allschwil-Schönenbuch",
    user: "rb.allschwil-schönenbuch",
    abo: "Content Service",
  },
  {
    Id: 219,
    sequence_name: "RB am Bichelsee",
    user: "rb.am bichelsee",
    abo: "Content Service",
  },
  {
    Id: 171,
    sequence_name: "RB am Lindenberg",
    user: "rb.am lindenberg",
    abo: "Content Service",
  },
  {
    Id: 317,
    sequence_name: "RB am Ricken",
    user: "rb.am ricken",
    abo: "Content Service",
  },
  {
    Id: 111,
    sequence_name: "RB Amriswil Bischofszell",
    user: "rb.AB",
    abo: "Content Studio",
  },
  {
    Id: 223,
    sequence_name: "RB an der Limmat",
    user: "rb.an der limmat",
    abo: "Content Service",
  },
  {
    Id: 73,
    sequence_name: "RB Balsthal-Lauperdorf",
    user: "rb.balsthal-laupersdorf",
    abo: "Content Service",
  },
  {
    Id: 211,
    sequence_name: "RB Basel",
    user: "rb.basel",
    abo: "Content Service",
  },
  {
    Id: 258,
    sequence_name: "RB Belalp-Simplon",
    user: "rb.belalp-simplon",
    abo: "Content Studio",
  },
  {
    Id: 215,
    sequence_name: "RB Benken",
    user: "rb.benken",
    abo: "Content Service",
  },
  {
    Id: 246,
    sequence_name: "RB Bern",
    user: "rb.bernforum",
    abo: "Content Service",
  },
  {
    Id: 170,
    sequence_name: "RB Berneck-Au",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 118,
    sequence_name: "RB Beromünster",
    user: "rb.beromünster",
    abo: "Content Service",
  },
  {
    Id: 124,
    sequence_name: "RB Bielersee",
    user: "rb.bielersee",
    abo: "Content Service",
  },
  {
    Id: 95,
    sequence_name: "RB Bündner Rheintal",
    user: "rb.bündner rheintal",
    abo: "Content Studio",
  },
  {
    Id: 1324,
    sequence_name: "RB Buttisholz-Ruswil",
    user: "rb.buttisholz-ruswil",
    abo: "Content Service",
  },
  {
    Id: 210,
    sequence_name: "RB Cadi",
    user: "rb.cadi",
    abo: "Content Service",
  },
  {
    Id: 80,
    sequence_name: "RB Cham-Steinhausen",
    user: "rb.cham",
    abo: "Content Studio",
  },
  {
    Id: 229,
    sequence_name: "RB Diepoldsau-Schmitter",
    user: "rb.diepoldsau-schmitter",
    abo: "Content Studio",
  },
  {
    Id: 318,
    sequence_name: "RB Dornach",
    user: "rb.dornach",
    abo: "Content Service",
  },
  {
    Id: 74,
    sequence_name: "RB Dulliken-Starrkirch",
    user: "rb.dulliken",
    abo: "Content Service",
  },
  {
    Id: 237,
    sequence_name: "RB Dünnerntal-Guldental",
    user: "rb.dunnerntal-guldental",
    abo: "Content Service",
  },
  {
    Id: 154,
    sequence_name: "RB Einsiedeln-Ybrig",
    user: "rb.einsiedeln",
    abo: "Content Service",
  },
  {
    Id: 665,
    sequence_name: "RB Emmen",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 97,
    sequence_name: "RB Flawil",
    user: "rb.flawil",
    abo: "Content Service",
  },
  {
    Id: 1357,
    sequence_name: "RB Frauenfeld",
    user: "",
    abo: "Content Studio",
  },
  {
    Id: 69,
    sequence_name: "RB Freiburg Ost (= Est)",
    user: "rb.freiburg-ost",
    abo: "Content Studio",
  },
  {
    Id: 169,
    sequence_name: "RB Gäu-Bipperamt",
    user: "rb.gäu-bipperamt",
    abo: "Content Service",
  },
  {
    Id: 153,
    sequence_name: "RB Gilgenberg",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 104,
    sequence_name: "RB Glarnerland",
    user: "rb.glarnerland",
    abo: "Content Service",
  },
  {
    Id: 119,
    sequence_name: "RB Goldach",
    user: "rb.goldach",
    abo: "Content Service",
  },
  {
    Id: 77,
    sequence_name: "RB Haslital-Brienz",
    user: "rb.haslital-brienz",
    abo: "Content Service",
  },
  {
    Id: 221,
    sequence_name: "RB HeIden",
    user: "rb.heIden",
    abo: "Content Service",
  },
  {
    Id: 85,
    sequence_name: "RB Hitzkirchertal",
    user: "rb.hitzkirchertal",
    abo: "Content Service",
  },
  {
    Id: 136,
    sequence_name: "RB Horw",
    user: "rb.horw",
    abo: "Content Service",
  },
  {
    Id: 631,
    sequence_name: "RB Hünenberg",
    user: "rb.hünenberg",
    abo: "Content Service",
  },
  {
    Id: 320,
    sequence_name: "RB im Entlebuch",
    user: "",
    abo: "Content Studio",
  },
  {
    Id: 70,
    sequence_name: "RB Jungfrau",
    user: "rb.jungfrau",
    abo: "Content Service",
  },
  {
    Id: 68,
    sequence_name: "RB Kelleramt-Albis",
    user: "rb.kelleramt-albis",
    abo: "Content Studio",
  },
  {
    Id: 139,
    sequence_name: "RB Lägern-Baregg",
    user: "rb.lägern-baregg",
    abo: "Content Service",
  },
  {
    Id: 160,
    sequence_name: "RB Laufental-Thierstein",
    user: "rb.Laufental-Thierstein",
    abo: "Content Service",
  },
  {
    Id: 311,
    sequence_name: "RB Leimental",
    user: "rb.leimental",
    abo: "",
  },
  {
    Id: 109,
    sequence_name: "RB Liestal-Oberbaselbiet",
    user: "rb.liestal",
    abo: "Content Service",
  },
  {
    Id: 1227,
    sequence_name: "RB Luzern",
    user: "rb.luzern",
    abo: "Content Service",
  },
  {
    Id: 99,
    sequence_name: "RB Luzerner Hinterland",
    user: "rb.luzernerhinterland",
    abo: "Content Service",
  },
  {
    Id: 108,
    sequence_name: "RB Marbach-Rebstein",
    user: "rb.marbach-rebstein",
    abo: "Content Service",
  },
  {
    Id: 89,
    sequence_name: "RB Menzingen-Neuheim",
    user: "rb.menzingen-neuheim",
    abo: "Content Service",
  },
  {
    Id: 87,
    sequence_name: "RB Mittelbünden",
    user: "rb.mittelbünden",
    abo: "Content Studio",
  },
  {
    Id: 159,
    sequence_name: "RB Mittelrheintal",
    user: "rb.mittelrheintal",
    abo: "Content Service",
  },
  {
    Id: 103,
    sequence_name: "RB Mittelthurgau",
    user: "rb.mittelthurgau",
    abo: "Content Service",
  },
  {
    Id: 98,
    sequence_name: "RB Mittleres Toggenburg",
    user: "rb.mittleres toggenburg",
    abo: "Content Service",
  },
  {
    Id: 27,
    sequence_name: "RB Möhlin",
    user: "rb.möhlin",
    abo: "Content Studio",
  },
  {
    Id: 961,
    sequence_name: "RB Münchwilen-Tobel",
    user: "rb.tobel",
    abo: "Content Service",
  },
  {
    Id: 173,
    sequence_name: "RB Muotathal",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 1258,
    sequence_name: "RB Nesslau",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 234,
    sequence_name: "RB Neukirch-Romanshorn",
    user: "rb.neukirch-romanshorn",
    abo: "Content Service",
  },
  {
    Id: 212,
    sequence_name: "RB NIdwalden",
    user: "rb.gander",
    abo: "Content Service",
  },
  {
    Id: 213,
    sequence_name: "RB NIdwalden",
    user: "rb.halbeisen",
    abo: "Content Service",
  },
  {
    Id: 212,
    sequence_name: "RB Niederhelfenschwil",
    user: "rb.niederhelfenschwil",
    abo: "Content Service",
  },
  {
    Id: 1060,
    sequence_name: "RB Oberes Emmental (kein Kunde)",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 115,
    sequence_name: "RB Oberes Rheintal",
    user: "rb.oberes-rheintal",
    abo: "Content Service",
  },
  {
    Id: 168,
    sequence_name: "RB Oberfreiamt",
    user: "rb.oberfreiamt",
    abo: "Content Service",
  },
  {
    Id: 151,
    sequence_name: "RB Oberseetal",
    user: "rb.oberseetal",
    abo: "Content Service",
  },
  {
    Id: 147,
    sequence_name: "RB Obertoggenburg",
    user: "rb.Obertoggenburg",
    abo: "Content Service",
  },
  {
    Id: 148,
    sequence_name: "RB Obwalden",
    user: "rb.obwalden",
    abo: "Content Service",
  },
  {
    Id: 167,
    sequence_name: "RB Rechter Zürichsee",
    user: "rb.rechterzuerichsee",
    abo: "Content Studio",
  },
  {
    Id: 88,
    sequence_name: "RB Regio Altnau",
    user: "rb.regio-altnau",
    abo: "Content Service",
  },
  {
    Id: 66,
    sequence_name: "RB Regio Arbon",
    user: "rb.regio arbon",
    abo: "Content Service",
  },
  {
    Id: 697,
    sequence_name: "RB Regio Frick",
    user: "rb.regio-frick",
    abo: "Content Studio",
  },
  {
    Id: 1093,
    sequence_name: "RB Regio Laufenburg",
    user: "rb.regio laufenburg",
    abo: "Content Service",
  },
  {
    Id: 730,
    sequence_name: "RB Region Glatt",
    user: "rb.oberembrach",
    abo: "Content Service",
  },
  {
    Id: 1159,
    sequence_name: "RB Region Leuk",
    user: "rb.region-leuk",
    abo: "Content Service",
  },
  {
    Id: 233,
    sequence_name: "RB Region linker Zürichsee",
    user: "rb.linkerzuerichsee",
    abo: "Content Service",
  },
  {
    Id: 364,
    sequence_name: "RB Region Rohrschach",
    user: "",
    abo: "Content Studio",
  },
  {
    Id: 310,
    sequence_name: "RB Region Visp",
    user: "rb.region-visp",
    abo: "Content Service",
  },
  {
    Id: 302,
    sequence_name: "RB Region Zofingen",
    user: "rb.region zofingen",
    abo: "Content Service",
  },
  {
    Id: 175,
    sequence_name: "RB Regio Sirnach",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 67,
    sequence_name: "RB Regio Uzwil",
    user: "rb.oberbüren",
    abo: "Content Service",
  },
  {
    Id: 114,
    sequence_name: "RB Reinach BL",
    user: "rb.reinachbl",
    abo: "Content Service",
  },
  {
    Id: 155,
    sequence_name: "RB Rickenbach-Wilen",
    user: "rb.rickenbach",
    abo: "Content Service",
  },
  {
    Id: 65,
    sequence_name: "RB Rigi",
    user: "rb.rigi",
    abo: "Content Service",
  },
  {
    Id: 316,
    sequence_name: "RB Risch-Rotkreuz",
    user: "rb.risch-rotkreuz",
    abo: "Content Service",
  },
  {
    Id: 294,
    sequence_name: "RB Rohrdorferberg-Fislisbach",
    user: "rb.rohrdorferberg-fislisbach",
    abo: "Content Studio",
  },
  {
    Id: 209,
    sequence_name: "RB Rothenburg",
    user: "rb.rothenburg",
    abo: "Content Service",
  },
  {
    Id: 64,
    sequence_name: "RB Sarganserland",
    user: "rb.sarganserland",
    abo: "Content Service",
  },
  {
    Id: 244,
    sequence_name: "RB Schächental",
    user: "rb.schächental",
    abo: "Content Service",
  },
  {
    Id: 100,
    sequence_name: "RB Schaffhausen",
    user: "rb.schaffhausen",
    abo: "Content Service",
  },
  {
    Id: 829,
    sequence_name: "RB Schänis-Amden",
    user: "rb.schaenis-amden",
    abo: "Content Service",
  },
  {
    Id: 102,
    sequence_name: "RB Seeland",
    user: "rb.seeland",
    abo: "Content Studio",
  },
  {
    Id: 135,
    sequence_name: "RB Sempachersee-Süd",
    user: "rb.sempachersee",
    abo: "Content Service",
  },
  {
    Id: 1522,
    sequence_name: "RB Sennwald",
    user: "rb.sennwald",
    abo: "Content Service",
  },
  {
    Id: 174,
    sequence_name: "RB Siggenthal-Würenlingen",
    user: "rb.siggenthal",
    abo: "Content Studio",
  },
  {
    Id: 259,
    sequence_name: "RB St.Gallen",
    user: "rb.St_Gallen",
    abo: "Content Studio",
  },
  {
    Id: 96,
    sequence_name: "RB Surbtal-Wehntal",
    user: "rb.surbtal-wehntal",
    abo: "Content Service",
  },
  {
    Id: 239,
    sequence_name: "RB Surselva",
    user: "rb.surselva",
    abo: "Content Service",
  },
  {
    Id: 928,
    sequence_name: "RB Tessin",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 71,
    sequence_name: "RB Thalwil",
    user: "rb.Thalwil",
    abo: "Content Service",
  },
  {
    Id: 123,
    sequence_name: "RB Thunersee",
    user: "rb.thunersee",
    abo: "Content Studio",
  },
  {
    Id: 110,
    sequence_name: "RB Untere Emme",
    user: "rb.untere emme",
    abo: "Content Service",
  },
  {
    Id: 138,
    sequence_name: "RB Unteres Toggenburg",
    user: "rb.unteres-toggenburg",
    abo: "Content Service",
  },
  {
    Id: 466,
    sequence_name: "RB Villmergen",
    user: "rb.villmergen",
    abo: "Content Service",
  },
  {
    Id: 236,
    sequence_name: "RB Waldkirch",
    user: "rb.waldkirch",
    abo: "Content Service",
  },
  {
    Id: 142,
    sequence_name: "_RB Walensee Spezialauftrag (kein Kunde)",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 250,
    sequence_name: "RB Wängi-Matzingen",
    user: "rb.waengi-matzingen",
    abo: "Content Service",
  },
  {
    Id: 164,
    sequence_name: "RB Wasseramt-Buchsi",
    user: "rb.wasseramt-buchsi",
    abo: "Content Service",
  },
  {
    Id: 105,
    sequence_name: "RB Wegenstettertal",
    user: "rb.wegenstettertal",
    abo: "Content Service",
  },
  {
    Id: 296,
    sequence_name: "RB Weinland",
    user: "rb.weinland",
    abo: "Content Service",
  },
  {
    Id: 235,
    sequence_name: "RB Weissenstein",
    user: "rb.weissenstein",
    abo: "Content Service",
  },
  {
    Id: 664,
    sequence_name: "RB Wil",
    user: "rb.wil",
    abo: "Content Service",
  },
  {
    Id: 298,
    sequence_name: "RB Winkeln",
    user: "rb.winkeln",
    abo: "Content Service",
  },
  {
    Id: 92,
    sequence_name: "RB Winterthur",
    user: "rb.Winterthur",
    abo: "Content Studio",
  },
  {
    Id: 93,
    sequence_name: "RB Wohlen",
    user: "rb.wohlen",
    abo: "Content Service",
  },
  {
    Id: 240,
    sequence_name: "RB Zufikon",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 322,
    sequence_name: "RB Zug",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 433,
    sequence_name: "RB Zuger Verband",
    user: "rb.zuger-verband",
    abo: "Content Service",
  },
  {
    Id: 129,
    sequence_name: "RB Zürcher Oberland",
    user: "rb.zuercheroberland",
    abo: "Content Service",
  },
  {
    Id: 106,
    sequence_name: "RB Zürich",
    user: "rb.zürich",
    abo: "Content Service",
  },
  {
    Id: 230,
    sequence_name: "RB Zürich Flughafen",
    user: "rb.zürich flughafen",
    abo: "Content Service",
  },
  {
    Id: 1027,
    sequence_name: "Région du Valais Romand",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 172,
    sequence_name: "_RB ALLE",
    user: "",
    abo: "Content Service",
  },
  {
    Id: 1588,
    sequence_name: "BR Franches-Montagnes",
    user: "br.franches-montagnes",
    abo: "Content Service",
  },
  {
    Id: 1589,
    sequence_name: "BR Mendrisio e Valle di Muggio",
    user: "br.mendrisio",
    abo: "Content Service",
  },
  {
    Id: 1590,
    sequence_name: "BR del Moesano",
    user: "br.del-moesano",
    abo: "Content Service",
  },
  {
    Id: 1591,
    sequence_name: "BR de Sierre & Région",
    user: "br.de sierre et région",
    abo: "Content Service",
  },
  {
    Id: 1592,
    sequence_name: "BR de Monthey",
    user: "br.de Monthey",
    abo: "Content Service",
  },
  {
    Id: 1593,
    sequence_name: "BR Valposchiavo",
    user: "br.valposchiavo",
    abo: "Content Service",
  },
  {
    Id: 1594,
    sequence_name: "RB Würenlos",
    user: "rb.würenlos",
    abo: "Content Service",
  },
  {
    Id: 1595,
    sequence_name: "RB Werdenberg",
    user: "rb.werdenberg",
    abo: "Content Service",
  },
  {
    Id: 1596,
    sequence_name: "BR Sion et Région",
    user: "br.sion et région",
    abo: "Content Service",
  },
  {
    Id: 1598,
    sequence_name: "RB Olten",
    user: "rb.olten",
    abo: "Content Service",
  },
  {
    Id: 1225,
    sequence_name: "RB Schulung",
    user: "rb.schulung",
    abo: "Content Studio",
  },
  {
    Id: 1918,
    sequence_name: "_Leanflow Test",
    user: "f.vogel",
    abo: "Content Studio",
  },
  {
    Id: 1918,
    sequence_name: "_Leanflow Test",
    user: "leanflow.muntwyler",
    abo: "Content Studio",
  },
  {
    Id: 1918,
    sequence_name: "_Leanflow Test",
    user: "leanflow",
    abo: "Content Service",
  },
];
